"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lerp = exports.sampleRange = exports.evaluateFourierSeries = exports.calculateFourierCoefficients = exports.FOURIER_FUNCTIONS = void 0;
// Common periodic functions for Fourier analysis
exports.FOURIER_FUNCTIONS = [
    {
        key: 'square',
        label: 'Square Wave',
        f: (x) => Math.sign(Math.sin(x)),
        period: 2 * Math.PI,
        note: 'Discontinuous function with sharp transitions.'
    },
    {
        key: 'sawtooth',
        label: 'Sawtooth Wave',
        f: (x) => {
            const normalized = ((x % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);
            return (2 * normalized / (2 * Math.PI)) - 1;
        },
        period: 2 * Math.PI,
        note: 'Linear ramp function with periodic discontinuities.'
    },
    {
        key: 'triangle',
        label: 'Triangle Wave',
        f: (x) => {
            const normalized = ((x % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);
            const halfPeriod = Math.PI;
            if (normalized < halfPeriod) {
                return (2 * normalized / halfPeriod) - 1;
            }
            else {
                return 3 - (2 * normalized / halfPeriod);
            }
        },
        period: 2 * Math.PI,
        note: 'Continuous piecewise linear function.'
    },
    {
        key: 'rectified',
        label: 'Half-Wave Rectified',
        f: (x) => Math.max(0, Math.sin(x)),
        period: 2 * Math.PI,
        note: 'Sine wave with negative portions clipped.'
    },
    {
        key: 'pulse',
        label: 'Pulse Train',
        f: (x) => {
            const normalized = ((x % (2 * Math.PI)) + 2 * Math.PI) % (2 * Math.PI);
            return normalized < Math.PI ? 1 : 0;
        },
        period: 2 * Math.PI,
        note: 'Periodic rectangular pulses.'
    }
];
// Calculate Fourier coefficients a_n and b_n
function calculateFourierCoefficients(func, n) {
    const period = func.period;
    const samples = 1000;
    const dx = period / samples;
    let a = 0;
    let b = 0;
    for (let i = 0; i < samples; i++) {
        const x = i * dx;
        const y = func.f(x);
        if (n === 0) {
            a += y;
        }
        else {
            a += y * Math.cos(2 * Math.PI * n * x / period);
            b += y * Math.sin(2 * Math.PI * n * x / period);
        }
    }
    a *= dx / period;
    b *= dx / period;
    return { a, b };
}
exports.calculateFourierCoefficients = calculateFourierCoefficients;
// Evaluate Fourier series at a point
function evaluateFourierSeries(func, x, terms) {
    const period = func.period;
    const { a: a0 } = calculateFourierCoefficients(func, 0);
    let sum = a0 / 2;
    for (let n = 1; n <= terms; n++) {
        const { a, b } = calculateFourierCoefficients(func, n);
        sum += a * Math.cos(2 * Math.PI * n * x / period) +
            b * Math.sin(2 * Math.PI * n * x / period);
    }
    return sum;
}
exports.evaluateFourierSeries = evaluateFourierSeries;
// Sample a range for plotting
function sampleRange(min, max, samples) {
    const step = (max - min) / (samples - 1);
    const xs = [];
    for (let i = 0; i < samples; i++) {
        xs.push(min + i * step);
    }
    return xs;
}
exports.sampleRange = sampleRange;
// Animation helper for smooth transitions
function lerp(start, end, t) {
    return start + (end - start) * t;
}
exports.lerp = lerp;
